import {Link} from 'react-router-dom'
import {getCourses} from '../data/course-data';
import { useState, useEffect } from 'react';
import './courses.css';

const CourseSkeleton = () => (
    <div className="col-lg-4 col-md-6">
        <div className="course-style-5 skeleton-card">
            <div className="course-header">
                <div className="course-thumb skeleton-image"></div>
            </div>
            <div className="course-content">
                <div className="course-meta">
                    <span className="skeleton-text" style={{ width: '100px' }}></span>
                    <span className="skeleton-text" style={{ width: '60px' }}></span>
                </div>
                <div className="skeleton-text" style={{ width: '80%', height: '24px', marginBottom: '1rem' }}></div>
                <div className="course-footer">
                    <span className="skeleton-text" style={{ width: '80px' }}></span>
                    <div className="skeleton-circle"></div>
                </div>
            </div>
        </div>
    </div>
);

const Courses = () => {
    const allCourses = getCourses();
    const [searchTerm, setSearchTerm] = useState('');
    const [loading, setLoading] = useState(true);
    
    useEffect(() => {
        // Simulate loading delay
        const timer = setTimeout(() => {
            setLoading(false);
        }, 1500);

        return () => clearTimeout(timer);
    }, []);

    // Enhanced search functionality similar to SQL LIKE
    const filteredCourses = allCourses.filter(course => {
        if (!searchTerm.trim()) return true;
        
        const searchWords = searchTerm.toLowerCase().split(/\s+/).filter(word => word.length > 0);
        const courseName = course.name.toLowerCase();
        const courseDescription = (course.description || '').toLowerCase();
        
        // Check if any of the search words match either the name or description
        return searchWords.some(word => 
            courseName.includes(word) || 
            courseDescription.includes(word)
        );
    });

    return(
        <div>
        <section className="page-header">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8 col-xl-8">
                        <div className="title-block">
                            <h1>Explore Our Courses</h1>
                        </div>
                        </div>
                    </div>
                </div>
        </section>
        <section className="section-padding page" >
            <div className="course-top-wrap">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 mx-auto">
                            <div className="topbar-search">
                                <form onSubmit={(e) => e.preventDefault()}>
                                    <div className="search-wrapper">
                                        <input 
                                            type="text"  
                                            placeholder="Search courses (e.g., web development, design)" 
                                            className="form-control"
                                            value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                        />
                                        <button type="submit" className="search-btn">
                                            <i className="fa fa-search"></i>
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    
            <div className="container">
                <div className="row g-4">
                {loading ? (
                    // Show 6 skeleton cards while loading
                    Array(6).fill().map((_, index) => (
                        <CourseSkeleton key={index} />
                    ))
                ) : filteredCourses.map(course => (
                    <div key={course.slug} className="col-lg-4 col-md-6">
                        <Link to={`/courses/${course.slug}`} className="course-card-link">
                            <div className="course-style-5">
                                <div className="course-header">
                                    <div className="course-thumb">
                                        <img src={course.img} alt={course.alt} />
                                    </div>
                                </div>
    
                                <div className="course-content">
                                    <div className="course-meta">
                                        <span className="lessons">
                                            <i className="far fa-play-circle me-2" style={{ color: '#8A038C' }}></i>
                                            {course.curriculum.length} Lessons
                                        </span>
                                        <span className="label">Beginner</span>
                                    </div>
                                    
                                    <h4>{course.name}</h4>
                                    
                                    <div className="course-footer">
                                        <span className="students">
                                            <i className="far fa-user-alt me-2" style={{ color: '#8A038C' }}></i>
                                            {Math.floor(Math.random() * 25) + 5} students
                                        </span>
                                        <div className="rounded-btn">
                                            <i className="fa fa-long-arrow-right"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Link>
                    </div> 
                ))}
                </div>
            </div>
        </section>
        </div>
    )
}

export default Courses;